import { createSlice } from '@reduxjs/toolkit'
import { FiltersState } from './types'
import { getSelectedFiltersCount, getSelectedFiltersList } from 'utils/filters'
import { CAR_TYPES } from 'constants/carTypes'

const initialCarTypes = CAR_TYPES.map((type) => ({
  value: type,
  selected: true,
}))

export const initialState: FiltersState = {
  filters: {
    activityHistory: {},
    priceList: {},
    stopSales: {},
    applications: {},
    profileList: {},
    profileArchive: {},
    locations: {},
    equipments: {},
    cars: {},
    dashboard: {
      carCategories: initialCarTypes,
    },
    bookingHistory: {},
  },
  selectedFiltersCount: {
    activityHistory: 0,
    priceList: 0,
    stopSales: 0,
    applications: 0,
    profileList: 0,
    profileArchive: 0,
    locations: 0,
    equipments: 0,
    cars: 0,
    dashboard: 0,
    bookingHistory: 0,
  },
  selectedFilters: {
    activityHistory: {},
    priceList: {},
    stopSales: {},
    applications: {},
    profileList: {},
    profileArchive: {},
    locations: {},
    equipments: {},
    cars: {},
    dashboard: {},
    bookingHistory: {},
  },
  filtersCompanyId: {},
}

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilterItems(state, action) {
      const key = action.payload.key as keyof typeof initialState.filters
      state.filters[key] = action.payload.items
      state.selectedFiltersCount[key] = getSelectedFiltersCount(
        action.payload.items
      )
      state.selectedFilters[key] = getSelectedFiltersList(state.filters[key])
      if (action.payload.companyId !== undefined) {
        state.filtersCompanyId[key] = action.payload.companyId
      }
    },
    resetFiltersByKey(state, action) {
      const key = action.payload as keyof typeof initialState.filters
      state.filters[key] = initialState.filters[key]
      state.selectedFilters[key] = initialState.selectedFilters[key]
      state.selectedFiltersCount[key] = initialState.selectedFiltersCount[key]
      delete state.filtersCompanyId[key]
    },
    selectAllFiltersByType(state, action) {
      const filterKey = action.payload
        .filterKey as keyof typeof initialState.filters
      state.filters[filterKey][action.payload.key] = state.filters[filterKey][
        action.payload.key
      ].map((el) => ({ value: el.value, selected: action.payload.isSelect }))
      state.selectedFiltersCount[filterKey] = getSelectedFiltersCount(
        state.filters[filterKey]
      )
      state.selectedFilters[filterKey] = getSelectedFiltersList(
        state.filters[filterKey]
      )
    },
    resetSelectedFilters(state) {
      state.selectedFilters = initialState.selectedFilters
      state.selectedFiltersCount = initialState.selectedFiltersCount
    },
    resetStopSalesFilters(state) {
      state.selectedFilters.stopSales = initialState.selectedFilters.stopSales
      state.selectedFiltersCount.stopSales =
        initialState.selectedFiltersCount.stopSales
    },
    resetPriceListFilters(state) {
      state.selectedFilters.priceList = initialState.selectedFilters.priceList
      state.selectedFiltersCount.priceList =
        initialState.selectedFiltersCount.priceList
    },
  },
})

export const filtersReducer = filtersSlice.reducer
export const {
  resetSelectedFilters,
  resetFiltersByKey,
  setFilterItems,
  selectAllFiltersByType,
  resetPriceListFilters,
  resetStopSalesFilters,
} = filtersSlice.actions
